// @flow
import React, { Component } from 'react';
import { socketEmit } from '../../../../socket';
import { openDialog } from '../../base/dialog';
import { JitsiRecordingConstants } from '../../base/lib-jitsi-meet';
import StopLiveStreamDialog from '../../recording/components/LiveStream/web/StopLiveStreamDialog';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../constant';
import { setDefaultRecordingType, setDisableRecIcon, setDoHangUp, setRecordingModalAction, setRecordingModalCount } from '../redux/tool-webjam-v2/actions';
import { hideApiLoader, setRecording, showApiLoader, showToastPopup, stopRecording } from '../redux/tool-webjam/actions';
import { dispatch, getStore } from '../Utils';
import { getRecordingStreamingType, sendRecordingEmailApi } from '../welcome-dashboard/Request.d';
import { stopRecordingAPI } from './toolbar/recording-function';
import { CURRENT_ROOM_NAME } from '../../webjam/constant';

const ModalHandler = {
    stopRecording: async function () {
        const {
            recIpAddress,
            recTimeStamp,
            stemRecording,
            roomorIpAddress
        } = getStore(FEATURE_CUSTOM_REDUX);

        const {
            authOrganization,
            recordingModalCount
        } = getStore(FEATURE_CUSTOM_REDUX_V2);

        dispatch(setRecording({
            recordingStarted: 2 // set flag for current user which is started/stopped the recording
        }));

        let isJibriRecording = true; // check if recording is Started with jibri based on avstack

        let recordingTypeRes = await getRecordingStreamingType('?organization_id=' + authOrganization?._id)

        if (recordingTypeRes.data.status) {
            dispatch(setDefaultRecordingType(recordingTypeRes.data.data.recording_type));
            isJibriRecording = recordingTypeRes.data.data.recording_type == "JIBRI";
        }

        if (isJibriRecording == false) {
            stopRecordingAPI()
        }


        const { iAmRecorder } = getStore('features/base/config')

        let obj = {
            recordingip: recIpAddress,
            recordingkey: recTimeStamp
        };

        const { local } = getStore('features/base/participants');

        socketEmit("recording_status", {
            roomName: CURRENT_ROOM_NAME,
            location: window.location.origin,
            timestamp: recTimeStamp,
            status: false,
            // stemStatus: stemRecording,
            jitsiId: local.id,
            iAmRecorder,
            type: 2,
            count: 0
        });

        dispatch(setRecordingModalCount(0));

        const { conference } = getStore('features/base/conference');
        const { sessionDatas } = getStore('features/recording');
        const { status: statusConstants } = JitsiRecordingConstants;

        let _fileRecordingSession = sessionDatas.find(sessionData => sessionData.mode === JitsiRecordingConstants.mode.FILE
            && (sessionData.status === statusConstants.ON
                || sessionData.status === statusConstants.PENDING));


        console.log("recording will stop ", _fileRecordingSession)

        if (_fileRecordingSession) {
            conference.stopRecording(_fileRecordingSession.id);
            // this._toggleScreenshotCapture();
            dispatch(showApiLoader())
            setTimeout(function () {
                dispatch(hideApiLoader())

                dispatch(stopRecording({
                    recordingStopped: true
                }));
            }, 5000)
        }

        sendRecordingEmailApi({
            room: roomorIpAddress,
            domain: authOrganization.domain
        })

        dispatch(setRecordingModalCount(0))
        dispatch(showToastPopup({ toastModal: false, modalText: '' }));
        dispatch(setRecordingModalAction('stop'))
        return true;
    },

    continueRecording: function () {
        dispatch(showToastPopup({ toastModal: false, modalText: '' }));
        dispatch(setRecordingModalAction('continue'))
    },

    autoStopRecording: function () {
        let _this = this
        setTimeout(function () {
            dispatch(showToastPopup({ toastModal: false, modalText: '' }));
            _this.stopRecording()
        }, 10000)
    },

    leaveStopRecording: function () {
        dispatch(showToastPopup({ toastModal: false, modalText: '' }));
        dispatch(setDoHangUp(true))
    },

    stopStreaming: function () {
        dispatch(showToastPopup({ toastModal: false, modalText: '' }));
        dispatch(openDialog(StopLiveStreamDialog))
        dispatch(setDisableRecIcon(false));
    },

    continueStreaming: function () {
        dispatch(showToastPopup({ toastModal: false, modalText: '' }));
    },

    leaveStopStreaming: function () {
        dispatch(showToastPopup({ toastModal: false, modalText: '' }));
        dispatch(setDoHangUp(true))
    },
}

export default ModalHandler;